export default "__VITE_ASSET__BInNB$Fe__"